var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiCreateFileUpload } from '@/actions/FileActionsTs';
import { addToastId, deleteToastId } from '@/actions/ToastActions';
import { notifyUploading, updateNotifyUploading } from '@/helpers/action';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * file uploadの実行
 * @param options
 * @returns {Promise<unknown>}
 */
export const uploadFilePromise = (options) => __awaiter(void 0, void 0, void 0, function* () {
    const { dispatch, file, showProgress, unmountRef } = options;
    // ファイルの値を整形
    const formData = new FormData();
    formData.append('upload_file', file, file.name);
    // アップロードプログレス表示制御用のID
    let toastId = null;
    // アップロード実行
    try {
        const { payload } = yield wrapDispatch(dispatch, apiCreateFileUpload({ json: formData }, {
            wrapOnUploadProgress: (progress) => {
                // アップロードプログレスバー非表示、もしくはunmount状態であれば何もしない
                if (!showProgress || (unmountRef && unmountRef.current)) {
                    return;
                }
                if (toastId === null) {
                    // アップロードプログレスバーを表示
                    toastId = notifyUploading(progress);
                    dispatch(addToastId(toastId));
                }
                else {
                    // 表示中のアップロードプログレスバーを更新
                    updateNotifyUploading(toastId, progress);
                }
            },
        }));
        if (!payload) {
            // payload が取得出来なかった場合、throw
            throw new Error();
        }
        if (toastId && unmountRef && !unmountRef.current) {
            // payload が取得出来た場合、アップロードプログレスバーを100%にする
            updateNotifyUploading(toastId, 100);
        }
        return payload;
    }
    finally {
        if (toastId && unmountRef && !unmountRef.current) {
            // アップロードプログレスバーを削除
            dispatch(deleteToastId(toastId));
        }
    }
});
